import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <div className="not-found-card">
        <div className="not-found-title">404</div>
        <div className="not-found-subtitle">Page not found</div>
        <p className="not-found-description">
          The page you’re looking for doesn’t exist or may have been moved. Let’s get you
          back to a familiar place.
        </p>
        <div className="not-found-actions">
          <button
            type="button"
            className="not-found-button"
            onClick={() => navigate('/login', { replace: true })}
          >
            Go to Login
          </button>
          <button
            type="button"
            className="not-found-button secondary"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
        <div className="not-found-help">
          Need additional help? <a href="mailto:hr@gracesupermarket.in">Contact support</a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
